module.exports = __webpack_public_path__ + "media/tables_picto/Eyesblue-91a49817.svg";